export enum SupportedStatus {
  NONE, PARTIAL, FULL
}
